import { useState, useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import OnboardingOverlay from '../features/guide/OnboardingOverlay';
import { useKeyboardShortcuts } from '../hooks/useKeyboardShortcuts';
import { PlatformMessageBanner } from '../features/messages/PlatformMessageBanner';

export default function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const mainRef = useRef<HTMLElement>(null);
  useKeyboardShortcuts();

  useEffect(() => {
    if (mainRef.current) {
      if (typeof mainRef.current.scrollTo === 'function') {
        try {
          mainRef.current.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        } catch {
          // ignore
        }
      }
      mainRef.current.scrollTop = 0;
      mainRef.current.scrollLeft = 0;
    }
    const rafId = requestAnimationFrame(() => {
      if (mainRef.current) {
        if (typeof mainRef.current.scrollTo === 'function') {
          try {
            mainRef.current.scrollTo({ top: 0, left: 0, behavior: 'instant' });
          } catch {
            // ignore
          }
        }
        mainRef.current.scrollTop = 0;
        mainRef.current.scrollLeft = 0;
      }
    });
    return () => cancelAnimationFrame(rafId);
  }, [location.pathname]);

  return (
    <div className="flex h-screen flex-col overflow-hidden bg-[#0a0a0a]">
      <Header onToggleSidebar={() => setSidebarOpen((v) => !v)} />

      <div className="flex flex-1 overflow-hidden">
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        <main
          ref={mainRef}
          id="main-content"
          data-scroll-container
          tabIndex={-1}
          className="flex-1 overflow-y-auto"
        >
          <PlatformMessageBanner />
          <Outlet />
        </main>
      </div>

      <OnboardingOverlay />
    </div>
  );
}
